import { ApiResult, PaginatedResponse, request, safeRequest } from '@synergy/api';
import { SupplierMapping } from '@synergy/models';

import { Attribute } from '../../../../../../common/models/attribute';

export class SupplierAttributeMappingApi {
    constructor(protected baseUrl: string) {}

    public getAttributeMapping(
        supplierId: number,
        params: URLSearchParams = new URLSearchParams()
    ): Promise<ApiResult<PaginatedResponse<SupplierMapping<Attribute>>>> {
        return safeRequest(
            () => {
                return request.get<PaginatedResponse<SupplierMapping<Attribute>>>(
                    `${this.baseUrl}/suppliers/${supplierId}/attributes/mapping`,
                    { params }
                );
            },
            response => {
                return response.data;
            }
        );
    }

    public updateAttributeMapping(
        supplierId: number,
        attributeMapping: SupplierMapping<Attribute>
    ): Promise<ApiResult<SupplierMapping<Attribute>>> {
        return safeRequest(
            () =>
                request.post(`${this.baseUrl}/suppliers/${supplierId}/attributes/${attributeMapping.id}/mapping`, {
                    values: attributeMapping.supplierMapping,
                }),
            response => response.data
        );
    }
}
